var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.8143V11.5043C18.9991 13.1216 18.4754 14.6953 17.507 15.9907C16.5386 17.286 15.1775 18.2337 13.6265 18.6922C12.0756 19.1508 10.4179 19.0957 8.90085 18.5352C7.38376 17.9747 6.08849 16.9389 5.20822 15.5821C4.32795 14.2253 3.90984 12.6203 4.01626 11.0065C4.12267 9.39272 4.74791 7.85654 5.79871 6.6271C6.84951 5.39766 8.26959 4.54083 9.84714 4.1844C11.4247 3.82798 13.0752 3.99105 14.5525 4.64929",
    stroke: "#0E361C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0833 3.83333L11.5 13.4262L8.625 10.5512",
    stroke: "#0E361C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.f0d29e829bc63128557f3f55519aed18.svg";
export { ForwardRef as ReactComponent };